export default "__VITE_ASSET__Df9Z0y02__"